import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Products from './pages/Products'
import ProductDetails from './pages/ProductDetails'
import About from './pages/About'
import Quality from './pages/Quality'
import Contact from './pages/Contact'
import Disclaimer from './pages/Disclaimer'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import NotFound from './pages/NotFound'
import { isPageEnabled, pagesConfig } from './config/siteConfig'

/**
 * Conditional Route Component
 * Renders the page if enabled, otherwise redirects to home or shows 404
 */
const ConditionalRoute = ({ pageKey, element }) => {
  if (!isPageEnabled(pageKey)) {
    return <Navigate to={pagesConfig.home.path} replace />
  }
  return element
}

/**
 * Helper to get path without leading slash for nested routes
 * React Router nested routes don't need the leading slash
 */
const getRoutePath = (pageKey) => {
  const path = pagesConfig[pageKey]?.path || `/${pageKey}`
  // Remove leading slash for nested routes (except home which uses index)
  return path.startsWith('/') ? path.slice(1) : path
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path={pagesConfig.home.path} element={<Layout />}>
            {/* Home - always rendered if enabled */}
            <Route index element={<ConditionalRoute pageKey="home" element={<Home />} />} />
            
            {/* Products */}
            <Route path={getRoutePath('products')} element={<ConditionalRoute pageKey="products" element={<Products />} />} />
            <Route path={`${getRoutePath('products')}/:productId`} element={<ConditionalRoute pageKey="products" element={<ProductDetails />} />} />
            
            {/* Main Pages */}
            <Route path={getRoutePath('about')} element={<ConditionalRoute pageKey="about" element={<About />} />} />
            <Route path={getRoutePath('quality')} element={<ConditionalRoute pageKey="quality" element={<Quality />} />} />
            <Route path={getRoutePath('contact')} element={<ConditionalRoute pageKey="contact" element={<Contact />} />} />
            
            {/* Legal Pages */}
            <Route path={getRoutePath('disclaimer')} element={<ConditionalRoute pageKey="disclaimer" element={<Disclaimer />} />} />
            <Route path={getRoutePath('privacy')} element={<ConditionalRoute pageKey="privacy" element={<Privacy />} />} />
            <Route path={getRoutePath('terms')} element={<ConditionalRoute pageKey="terms" element={<Terms />} />} />
            
            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
